module.exports = __webpack_public_path__ + "static/media/add-service-03.01dc8d3c.png";